let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jUxvR")).then(() => parcelRequire('eLfTw'));